<template>
    <div style="padding: 10px 10px 10px 0;">
        <el-form :inline="true" :model="selectForm" ref="selectForm">
            <el-form-item label="日期" prop="queryDate">
                <el-date-picker v-model="selectForm.queryDate" type="daterange" align="right" unlink-panels clearable
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getAll">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="$refs.selectForm.resetFields(); getAll();">重置</el-button>
            </el-form-item>
            <!-- <el-form-item>
    				<el-button type="primary" @click="addRow">新增</el-button>
    			</el-form-item> -->
            <!-- <el-form-item>
    				<el-button type="primary" @click="dc">导出</el-button>
    			</el-form-item> -->
        </el-form>
        <!-- 表格 -->
        <el-table :data="data" style="width: 100%" border>
            <el-table-column prop="number" label="时间" align="center"></el-table-column>
            <el-table-column prop="name" label="值岗人" align="center"></el-table-column>
            <el-table-column prop="name" label="对应相机" align="center"></el-table-column>
            <el-table-column prop="name" label="值岗状态" align="center"></el-table-column>
            <!-- <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="text" @click="viewRow(scope.row)">查看</el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <!-- 分页 -->
        <el-pagination v-if="totalNum > 0" @size-change="sizeChange" @current-change="currentChange"
            :page-sizes="[10, 20, 30, 40]" :page-size="selectForm.rows" layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum" style="margin-top: 10px;">
        </el-pagination>
    </div>
</template>

<script>
import publicExport from '../../assets/js/publicExport.js';
export default {
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            data: [], //表格数据
            selectForm: { //查询条件
                page: 1, //当前页
                rows: 10, //页大小
                queryDate: [], //查询日期
            },
            show: false, //控制弹窗
            title: "新增",
        }
    },
    methods: {
        viewRow() { //查看
            alert("查看")
        },
        getAll() { //获取表格数据
            // this.$http.post(`/api/area/selectByPage`, this.selectForm).then(res => {
            //     this.data = res.data.data.items;
            //     this.totalNum = res.data.data.totalNum;
            // })
        },
        sizeChange(size) { //页大小被修改
            this.selectForm.rows = size;
            this.getAll();
        },
        currentChange(page) { //当前页被修改
            this.selectForm.page = page;
            this.getAll();
        },
    },
    created() {
        this.getAll();
    }
}
</script>

<style scoped="scoped">

</style>
